import {
  Box,
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
} from '@wegroup/design-system';
import React, { useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { ThemeContext } from 'styled-components';
import { IconArrow } from 'wg-fe-ui';
import { useFlowsSelector } from '../../../../common/src/utils/globalVariables';
import useSessionId from '../../../../flows/src/hooks/useSessionId';

const OffersToolbarBackButton: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const sessionId = useSessionId();
  const cancelRef = useRef<HTMLButtonElement>(null);
  const flowId = useFlowsSelector((state) => state.flows.metaData.flowId);

  // not using useTheme because the need of 'isImmo' prop from the theme
  const theme = useContext(ThemeContext);

  const { isOpen, onClose, onOpen } = useDisclosure();

  const handleOnClick = () => {
    history.push(`/flows/${flowId}/questions/${sessionId}`);
    onClose();
  };

  return (
    <>
      <Button
        ml="1"
        mr="4"
        color={theme['isImmo'] ? theme.secondary[200] : theme.secondary[300]}
        variant="link"
        leftIcon={
          <Box sx={{ '> svg': { transform: 'rotate(180deg)' } }}>
            <IconArrow
              color={
                theme['isImmo'] ? theme.secondary[200] : theme.secondary[300]
              }
            />
          </Box>
        }
        onClick={onOpen}
      >
        {t('Back to questions')}
      </Button>
      <AlertDialog
        motionPreset="slideInBottom"
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader textStyle="largeBodyBold">
              {t('Go back?')}
            </AlertDialogHeader>

            <AlertDialogBody>
              {t(
                'Are you sure you want to go back? You will lose any changes made to the offers and no offers will remain selected',
              )}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} variant="grayedGhost" onClick={onClose}>
                {t('Cancel')}
              </Button>
              <Button onClick={handleOnClick} ml={3}>
                {t('Go back')}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default OffersToolbarBackButton;
